import { Controller } from "@hotwired/stimulus";

// Mini-controller voor de mobiele "Jouw stoelen"-onderbalk: klik op de kop klapt de lijst in/uit
// (toggle .is-open op het controller-element). Los van de zaalplan-controller omdat het paneel in
// een andere kolom staat, buiten de .sp2-card-scope. Op desktop staat de lijst altijd open (CSS),
// dus deze toggle heeft daar geen zichtbaar effect.
export default class extends Controller {
  toggle() {
    this.element.classList.toggle("is-open");
  }
}
